import type { LayerConfig, PixelType } from './type';

export const CONTRIBUTIONS_PER_PIXEL = 200;

export const TREE_PATTERN = [
  '                         ',
  ' S                       ',
  '            B       S    ',
  '       S   BBB           ',
  '          BBBBB          ',
  '           BBB           ',
  '  S         B            ',
  '           GGG   S    S  ',
  '          GGSGG          ',
  '           GGG           ',
  '      S  GGLLGGG         ',
  '          LGGGG    S     ',
  '        LGGBGLGGG        ',
  '         GBGBGLL         ',
  '       GGGGBLGGGGG       ',
  '        GLLLGGGGG        ',
  '   S  GGGGGGGSGGLLG    S ',
  '       GBGGGGGGGGG       ',
  '     GGGGLLGGLLBGGG      ',
  '      GLLGGGGGBGBGG  S   ',
  '     GLGGGGGGGGBLGGG     ',
  '     GGGSGGGGGGGGGG      ',
  '   GGGGSGSGGGGGGGGGGG    ',
  ' S  GGGGSGGLLGGGGGGL     ',
  '   GGGGGLLGGGGGGGGGGLL S ',
  '    LLLLGGGGGGGGBGGGG    ',
  '  GGGGGGGGGLGGGGGGGGGGG  ',
  '    GGGGGGGGGLGGGGGLLL   ',
  '   GGLLGBGGGGGLLLGLGSGG  ',
  ' LLLLGGBGBGGGGGGGGGGGG   ',
  '  GGGGGGBGGLGGGGGGGGGGGG ',
  '  GGSGGGLLLGGGLGGGGGGG   ',
  '  GGGGLLGGGGGGGLGGGGBLGG ',
  ' LLLLLGGGGLLLGGGLLLGGGG  ',
  ' GGGGBGGGGGGGGGSGGLLLGGG ',
  '  GGGGGGLGGGGGGGGGGGGLG  ',
  '     GLLGGTTTTTGGGGG     ',
  '          TTTTT          ',
  '  S       TTTTT     S    ',
  '          TTTTT          ',
];

const calculateTotalPixels = () => {
  const row = TREE_PATTERN[0].length;
  const col = TREE_PATTERN.length;
  return row * col;
};

export const TOTAL_PIXELS = calculateTotalPixels();
export const ANIMATION_SPEED = 50;

// 트리 레이어 추가시 백그라운드와 레이어를 함께 추가해주세요.
export const TREE_LAYERS: LayerConfig[] = [
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'background',
    opacity: 1,
    baseColors: {
      B: '#b4bbd1',
      S: '#303030',
      G: '#828282',
      L: '#5f5f5f',
      T: '#625242',
      ' ': '#303030',
    },
  },
  {
    id: 'layer1',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#483b3b',
      ' ': '#576ec9',
    },
  },
  {
    id: 'highlight',
    opacity: 1,
    baseColors: {
      B: '#f43d3a',
      S: '#ffffff',
      G: '#16c174',
      L: '#05624e',
      T: '#07735c',
      ' ': '#576ec9',
    },
  },
];

export const PROCESSED_PIXELS = TREE_PATTERN.map(
  (row) => row.split('') as PixelType[],
);
